// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"K2-z","displaySixCardTiles":"L2-z"};